import { useForm } from "react-hook-form";
import { InputComponent } from "../../../components/InputComponent";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { GenericComponent } from "../../../components/GenericComponent";
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { TablaDinamica } from "../../../components/TablaDinamica";
import { useLazyParams } from "../../../hooks/useLazyParams";
import { PepParticipacionEmpresa } from "./PepParticipacionEmpresa";
import { PepParentescoService } from "../../../service/ficha/PepParentescoService";
import { PepParentesco } from "../../../models/ficha/PepParentesco";

export const PepAfinidad = ({ tipo, id, toast, permss, catalogos, soloLectura }) => {

    const generic = new GenericComponent();
    const omodel = new PepParentesco();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const pepSrv = new PepParentescoService();
    const [dialogAfinidad, setDialogAfinidad] = useState(false);
    const [afinidad, setAfinidad] = useState(null);
    const [load, setLoad] = useState(false);
    const [dialogEmpresa, setDialogEmpresa] = useState(false);
    const menuRef = useRef(null);
    const tablaAfinidad = useLazyParams({ modelo: omodel.model });
    const { inText } = InputComponent({ registers: tablaAfinidad.data, omodel, generic, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyAfinidad();
        // eslint-disable-next-line
    }, [tablaAfinidad.lazyParams, id]);

    const editAfinidad = () => {
        pepSrv.consulta(afinidad?.id, id, { tipo }).then(res => {
            const _afi = res.data;
            reset(_afi);
            setDialogAfinidad(true);
        });
    }

    const loadLazyAfinidad = () => {
        tablaAfinidad.setLoading(true);
        const _params = { ...tablaAfinidad.lazyParams, idp: id, tipo: tipo };
        pepSrv.lista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaAfinidad.setTotalRecords(res.data.total);
            tablaAfinidad.setData(res.data.registros);
        }).finally(() => tablaAfinidad.setLoading(false));
    }

    const onSubmitAfinidad = (data) => {
        data.idp = id;
        data.tipo = tipo;
        setLoad(true);

        const request = getValues('id') == null ? pepSrv.nuevo(data) : pepSrv.editar(data);
        request.then(res => {
            setDialogAfinidad(false);
            loadLazyAfinidad();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoad(false);
        });
    }

    const openNew = () => {
        setAfinidad(null);
        setDialogAfinidad(true);
        reset(defaultValues);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteAfinidad()
        });
    };

    const deleteAfinidad = () => {
        pepSrv.eliminar(afinidad?.id, id, { tipo }).then(res => {
            loadLazyAfinidad();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [
                    { label: 'Ver detalle', icon: 'pi pi-eye', command: () => editAfinidad() },
                    { label: 'Participación en empresas', icon: 'pi pi-building-columns', command: () => setDialogEmpresa(true) }
                ]
            }];
        }

        const items = [];
        if (permss?.actualizar && (!afinidad?.nemonico || afinidad.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editAfinidad() });
        if (permss?.actualizar)
            items.push({ label: 'Participación en empresas', icon: 'pi pi-building-columns', command: () => setDialogEmpresa(true) });
        if (permss?.eliminar && (!afinidad?.nemonico || afinidad?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });

        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_afinidad"
            aria-haspopup
            onClick={(e) => { setAfinidad(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600">
                {omodel.msgFamiliar}
            </span>
        </div>
    );

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_afinidad" />
            <TablaDinamica
                modelo={omodel.model}
                estadoTabla={tablaAfinidad}
                datos={tablaAfinidad.data}
                totalRegistros={tablaAfinidad.totalRecords}
                dataKey="id"
                acciones={ColumnaAcciones}
                header={cabeceraTabla()}
            />

            <Dialog visible={dialogAfinidad} header={soloLectura ? "Ver Información" : (getValues('id') == null ? "Nueva Información" : "Editar Información")} modal className="p-fluid modal-ssize"
                onHide={() => setDialogAfinidad(false)} style={{ width: '450px' }}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmitAfinidad, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-users text-primary"></i>
                                FAMILIAR / RELACIONADO PEP
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <Card className="mb-3 section-card">
                        <div className="formgrid grid">
                            {inText('parentesco', {}, 12)}
                            {inText('nombres', {}, 12)}
                        </div>
                    </Card>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={() => setDialogAfinidad(false)} />
                        </div>
                    ) : (
                        generic.buttonsForms(setDialogAfinidad, load)
                    )}
                </form>
            </Dialog >

            <Dialog visible={dialogEmpresa} header="Personas jurídicas - participación" modal className="p-fluid modal-ssize"
                onHide={() => setDialogEmpresa(false)} style={{ width: '600px' }}>
                <PepParticipacionEmpresa id={afinidad?.id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} loadLazyAfinidad={loadLazyAfinidad} />
            </Dialog>
        </>
    )
}
